export class AlertRulesData {
    constructor({
        id,
        name,
        summary,
        description,
        categoryId,
        fleetLowerLimit,
        fleetUpperLimit,
        isActive = true,
        vessels
    }) {
        this.id = id;
        this.name = name;
        this.summary = summary;
        this.description = description;
        this.categoryId = categoryId;
        this.fleetLowerLimit = fleetLowerLimit;
        this.fleetUpperLimit = fleetUpperLimit;
        this.vessels = vessels;
        this.isActive = isActive;
    }

}
